import RaceAuthenticationMethodField from './RaceAuthenticationMethodField';

export default RaceAuthenticationMethodField;
